import React, { Component } from 'react';
import { Table } from 'react-bootstrap';

const isUndefined = (obj) => (typeof obj === 'undefined' ? true : false);

class View extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			vipMemberList: [],
			evScannerUserList: [],
		};
	}

	componentWillMount() {
		let { selectedData } = this.props;

		if (
			!isUndefined(selectedData.get('userType')) &&
			selectedData.get('userType').toUpperCase() == 'VIP HOST'
		) {
			this.setState({ isLoading: true });

			var vipMemberQuery = new Parse.Query('MemberToken'),
				VipHost = Parse.Object.extend(Parse.User),
				vipHost = new VipHost();
			vipHost.id = selectedData.id;

			vipMemberQuery.equalTo('vipHost', vipHost);

			vipMemberQuery
				.find()
				.then((data) => {
					const label = (obj) => {
						return !isUndefined(obj) ? obj : '';
					};

					this.setState({
						isLoading: false,
						vipMemberList: data.map((item) => item.get('name')),
					});
				})
				.catch((err) => {
					this.setState({ isLoading: true });
					console.error('Get vip member error: ', err);
				});
		}

		if (
			!isUndefined(selectedData.get('userType')) &&
			selectedData.get('userType').toUpperCase() == 'PARTNER'
		) {
			this.setState({ isLoading: true });

			var userQuery = new Parse.Query(Parse.User);

			userQuery.containedIn(
				'objectId',
				Array.isArray(selectedData.get('evScannerUserConfig'))
					? selectedData.get('evScannerUserConfig')
					: []
			);

			userQuery
				.find()
				.then((data) => {
					const label = (obj) => {
						return !isUndefined(obj) ? obj : '';
					};

					this.setState({
						isLoading: false,
						vipMemberList: data.map((item) => item.get('name')),
					});
				})
				.catch((err) => {
					this.setState({ isLoading: true });
					console.error('Get evScannerUser error: ', err);
				});
		}
	}

	render() {
		let { selectedData } = this.props;

		let { isLoading, vipMemberList } = this.state;

		return (
			<Table bordered responsive>
				<tbody>
					<tr>
						<td>USERNAME</td>
						<td>
							{!isUndefined(selectedData.get('username'))
								? selectedData.get('username')
								: ''}
						</td>
					</tr>
					<tr>
						<td>NAME</td>
						<td>
							{!isUndefined(selectedData.get('name')) ? selectedData.get('name') : ''}
						</td>
					</tr>
					<tr>
						<td>EMAIL</td>
						<td>
							{!isUndefined(selectedData.get('email'))
								? selectedData.get('email')
								: ''}
						</td>
					</tr>
					<tr>
						<td>MEMBER ID</td>
						<td>
							{!isUndefined(selectedData.get('memberId'))
								? selectedData.get('memberId')
								: ''}
						</td>
					</tr>
					<tr>
						<td>USER TYPE</td>
						<td>
							{!isUndefined(selectedData.get('userType'))
								? selectedData.get('userType')
								: ''}
						</td>
					</tr>
					{!isUndefined(selectedData.get('userType')) &&
					selectedData.get('userType').toUpperCase() == 'MERCHANT'
						? [
								<tr>
									<td>MERCHANT</td>
									<td>
										{!isUndefined(selectedData.get('Merchant'))
											? selectedData.get('Merchant').get('name')
											: ''}
									</td>
								</tr>,
								<tr>
									<td>SEND RECEIPT EMAIL</td>
									<td>
										{!isUndefined(selectedData.get('isSendReceiptEmail'))
											? selectedData
													.get('isSendReceiptEmail')
													.toString()
													.toUpperCase()
											: 'FALSE'}
									</td>
								</tr>,
								<tr>
									<td>RECEIPT EMAIL RECIPIENT</td>
									<td>
										<div
											style={{
												maxHeight: '200px',
												overflowY: 'scroll',
											}}
										>
											{!isUndefined(selectedData.get('receiptEmailRecipient'))
												? selectedData
														.get('receiptEmailRecipient')
														.join(', ')
												: ''}
										</div>
									</td>
								</tr>,
								<tr>
									<td>PRINT RECEIPT</td>
									<td>
										{!isUndefined(selectedData.get('isPrintReceiptEnabled'))
											? selectedData
													.get('isPrintReceiptEnabled')
													.toString()
													.toUpperCase()
											: 'FALSE'}
									</td>
								</tr>,
								<tr>
									<td>RE-PRINT RECEIPT</td>
									<td>
										{!isUndefined(selectedData.get('isReprintReceiptEnabled'))
											? selectedData
													.get('isReprintReceiptEnabled')
													.toString()
													.toUpperCase()
											: 'FALSE'}
									</td>
								</tr>,
								<tr>
									<td>RE-PRINT LIMIT</td>
									<td>
										{!isUndefined(selectedData.get('reprintLimit'))
											? selectedData.get('reprintLimit')
											: ''}
									</td>
								</tr>,
						  ]
						: ''}
					{!isUndefined(selectedData.get('userType')) &&
					selectedData.get('userType').toUpperCase() == 'VIP HOST' ? (
						<tr>
							<td>VIP MEMBER</td>
							{isLoading ? (
								<td style={{ textAlign: 'center' }}>
									<i className="fa fa-spinner fa-spin fa-3x fa-lg"></i>
								</td>
							) : (
								<td>{vipMemberList.toString()}</td>
							)}
						</tr>
					) : (
						''
					)}
					{!isUndefined(selectedData.get('userType')) &&
					selectedData.get('userType').toUpperCase() == 'PARTNER'
						? [
								<tr>
									<td>Hide finance data</td>
									<td>
										{!isUndefined(selectedData.get('isHideFinanceData'))
											? selectedData
													.get('isHideFinanceData')
													.toString()
													.toUpperCase()
											: 'FALSE'}
									</td>
								</tr>,
								<tr>
									<td>Hide claimed data</td>
									<td>
										{!isUndefined(selectedData.get('isHideClaimedData'))
											? selectedData
													.get('isHideClaimedData')
													.toString()
													.toUpperCase()
											: 'FALSE'}
									</td>
								</tr>,
								<tr>
									<td>MERCHANT/EV SCANNER USER</td>
									{isLoading ? (
										<td style={{ textAlign: 'center' }}>
											<i className="fa fa-spinner fa-spin fa-3x fa-lg"></i>
										</td>
									) : (
										<td>{vipMemberList.toString()}</td>
									)}
								</tr>,
						  ]
						: ''}
				</tbody>
			</Table>
		);
	}
}

export default View;



// WEBPACK FOOTER //
// ./components/UserSetup/FormContainer/View.js